import firebase from "firebase";
import { db, auth } from "../../Firebase/firebase";
import { vuexfireMutations, firestoreAction } from "vuexfire";
import router from "../../router/index";
import { Date } from "core-js";
import Vue from "vue";
import { baseurl } from "../../helpers/helper";

const increment = firebase.firestore.FieldValue.increment(1);
const decrement = firebase.firestore.FieldValue.increment(-1);

export default {
  namespaced: true,
  state: {
    categories: [],
    currentCategory: null,
    fetchingItems: false,
    searchCategories: [],
  },

  mutations: {
    SET_MENUS(state, data) {
      state.categories = data;
    },
    SET_CATEGORY_ITEMS(state, { categoryName, data, newLoad }) {
      if (!state[categoryName]) {
        Vue.set(state, categoryName, []);
      }
      state[categoryName] = newLoad
        ? [...data]
        : [...state[categoryName], ...data];
    },
    SET_CATEGORY_NAME(state, name) {
      Vue.set(state, name, []);
    },
    SET_CATEGORIES(state, data) {
      state.categories = data;
    },
    SET_CURRENT_CATEGORY(state, data) {
      state.currentCategory = data;
    },
    FETCHING_ITEMS(state, status) {
      state.fetchingItems = status;
    },
  },

  getters: {
    categories(state) {
      return state.categories;
    },
  },

  actions: {
    async createCategory({ commit, dispatch }, form) {
      db.collection("categories")
        .doc(auth.currentUser.uid)
        .collection("userCategories")
        .add({
          name: form.category,
          title: form.category,
          description: form.description,
          is_active: true,
          items: [],
          createdAt: new Date(),
        })
        .then((response) => {
          const data = {
            title: "Success",
            message: "Successfully created category",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data, { root: true });
        });
    },

    searchCategories: firestoreAction(
      ({ commit, dispatch, state, bindFirestoreRef }, { limit, query }) => {
        bindFirestoreRef(
          "searchCategories",
          db
            .collection("categories")
            .doc(auth.currentUser.uid)
            .collection("userCategories")
            .where("name", ">=", query)
            .where("name", "<=", query + "\uf8ff")
            .where("is_active", "==", true)
            .orderBy("name", "desc")
            .limit(limit)
        );
      }
    ),

    async fetchCategories({ commit }) {
      db.collection("categories")
        .doc(auth.currentUser.uid)
        .collection("userCategories")
        .orderBy("createdAt", "desc")
        .onSnapshot((snapshot) => {
          let categoryArray = [];

          snapshot.forEach((doc) => {
            let post = doc.data();
            post.id = doc.id;

            categoryArray.push(post);
          });
          commit("SET_CATEGORIES", categoryArray);
        });
    },

    async fetchCategory({ commit }, categoryId) {
      const category = await db
        .collection("categories")
        .doc(auth.currentUser.uid)
        .collection("userCategories")
        .doc(categoryId)
        .get();
      const categoryObject = { ...category.data(), id: category.id };

      commit("SET_CURRENT_CATEGORY", categoryObject);
    },

    async fetchCategoryItems({ commit }, { categoryName, items, load ,companyId}) {
      const uid = companyId ? companyId : auth.currentUser.uid;
      const newLoad = load ? true : false;
      commit("FETCHING_ITEMS", true);
      const response = db
        .collection("Items")
        .doc(uid)
        .collection("userItems")
        .where(firebase.firestore.FieldPath.documentId(), "in", items)
        .onSnapshot((snapshot) => {
          let itemsArray = [];

          snapshot.forEach((doc) => {
            let post = doc.data();
            post.id = doc.id;

            itemsArray.push(post);
          });

          commit("FETCHING_ITEMS", false);
          commit("SET_CATEGORY_ITEMS", {
            categoryName,
            data: itemsArray,
            newLoad,
          });
        });

      return response;
    },

    async addItemsToCategory({ commit }, { categoryId, items }) {
      db.collection("categories")
        .doc(auth.currentUser.uid)
        .collection("userCategories")
        .doc(categoryId)
        .update({
          items: firebase.firestore.FieldValue.arrayUnion(...items),
        })
        .then((response) => {
          const data = {
            title: "Success",
            message: "Successfully added item(s)",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data, { root: true });
          return response;
        });
    },

    async editCategory({ commit, dispatch }, {categoryId,form}) {
      db.collection("categories")
        .doc(auth.currentUser.uid)
        .collection("userCategories")
        .doc(categoryId)
        .update({
          ...form,
          title:form.edit
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully updated category",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data,{root:true});
        });
    },

    async deleteCategory({ commit, dispatch }, {categoryId}) {
      db.collection("categories")
        .doc(auth.currentUser.uid)
        .collection("userCategories")
        .doc(categoryId)
        .update({
          is_active:false
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully deleted category",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data,{root:true});
        });
    },
  },
};
